/* PoscART — FAQ search + two-column layout helper        (2026-09-13)
 * ---------------------------------------------------------------------------
 * The FAQ page body (/pages/faq) is 55 <details> questions grouped under eight
 * <h2> headings. This injects a search box under the category pills and
 * filters those questions live, hiding any heading, grid or pill that has
 * nothing left in it. The two-column layout is pure CSS (poscart-overrides).
 *
 * Content stays in the page body — nothing here writes to it — so editing the
 * page in admin can never break the search, and this file no-ops on every
 * other page.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.pa-faq');
    if (!root || root.dataset.faqSearch === '1') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.pa-policy__item'));
    if (items.length < 6) return;
    root.dataset.faqSearch = '1';

    /* pair each <h2> with the grid that follows it ------------------------ */
    var sections = [];
    Array.prototype.slice.call(root.children).forEach(function (node) {
      if (node.tagName === 'H2' && node.id) {
        sections.push({ heading: node, grid: null, id: node.id });
      } else if (node.classList && node.classList.contains('pa-policy__grid')) {
        if (sections.length) sections[sections.length - 1].grid = node;
      }
    });

    var nav = root.querySelector('.pa-faq__nav');
    var pills = {};
    if (nav) {
      Array.prototype.slice.call(nav.querySelectorAll('a')).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#') pills[href.slice(1)] = a.parentNode || a;
      });
    }

    /* search UI ---------------------------------------------------------- */
    var box = document.createElement('div');
    box.className = 'pa-faqs';
    box.setAttribute('role', 'search');
    box.innerHTML =
      '<svg class="pa-faqs__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/>' +
      '<path d="M16.3 16.3 21 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<input type="search" class="pa-faqs__input" autocomplete="off" spellcheck="false" ' +
      'placeholder="Search the FAQs — sealing, fabric, dry pen, delivery…" aria-label="Search the FAQs">' +
      '<button type="button" class="pa-faqs__clear" aria-label="Clear search" hidden>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';

    var count = document.createElement('p');
    count.className = 'pa-faqs__count';
    count.setAttribute('role', 'status');
    count.setAttribute('aria-live', 'polite');

    var empty = document.createElement('p');
    empty.className = 'pa-faqs__empty';
    empty.hidden = true;
    empty.innerHTML =
      'No questions match that search. Try another word, or call ' +
      '<a href="tel:1300783961">1300 783 961</a> — we answer every one.';

    var anchor = nav || (sections[0] && sections[0].heading);
    if (!anchor) return;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.parentNode.insertBefore(count, box.nextSibling);
    var lastSection = sections[sections.length - 1];
    var emptyAnchor = (lastSection && lastSection.grid) || count;
    emptyAnchor.parentNode.insertBefore(empty, emptyAnchor.nextSibling);

    var input = box.querySelector('.pa-faqs__input');
    var clearBtn = box.querySelector('.pa-faqs__clear');

    /* index -------------------------------------------------------------- */
    function norm(value) {
      return (value || '')
        .toLowerCase()
        .replace(/[‘’]/g, "'")
        .replace(/[^a-z0-9' ]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    var haystack = items.map(function (el) { return norm(el.textContent); });
    var wasOpen = items.map(function (el) { return el.open; });

    function apply(query) {
      var terms = norm(query).split(' ').filter(Boolean);
      var shown = 0;

      items.forEach(function (el, i) {
        var hit = true;
        for (var t = 0; t < terms.length; t++) {
          if (haystack[i].indexOf(terms[t]) === -1) { hit = false; break; }
        }
        el.hidden = !hit;
        if (hit) shown++;
        el.open = terms.length ? (hit && shown <= 3) : wasOpen[i];
      });

      sections.forEach(function (s) {
        var alive = s.grid ? !!s.grid.querySelector('.pa-policy__item:not([hidden])') : true;
        if (s.heading) s.heading.hidden = !alive;
        if (s.grid) s.grid.hidden = !alive;
        var pill = pills[s.id];
        if (pill) pill.hidden = !alive;
      });

      clearBtn.hidden = terms.length === 0;
      empty.hidden = shown !== 0;
      count.textContent = terms.length
        ? (shown === 1 ? '1 question matches' : shown + ' of ' + items.length + ' questions match')
        : '';
      root.classList.toggle('is-searching', terms.length > 0);
    }

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var value = input.value;
      timer = setTimeout(function () { apply(value); }, 110);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) {
        event.stopPropagation();
        input.value = '';
        apply('');
      }
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      apply('');
    });

    var seeded = new URLSearchParams(window.location.search).get('q');
    if (seeded) { input.value = seeded; apply(seeded); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
